import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=c5457a52"
import script from "./DownloadIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5457a52')) {
      api.createRecord('c5457a52', component.options)
    } else {
      api.reload('c5457a52', component.options)
    }
    module.hot.accept("./DownloadIcon.vue?vue&type=template&id=c5457a52", function () {
      api.rerender('c5457a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/DownloadIcon.vue"
export default component.exports